import { useMutation } from '@occc-app/dataAccessLayer/utils';
import {
  LocationBulkSubmitterIdUpdateMutationOptions,
  useLocationBulkSubmitterIdUpdateMutation,
} from '@occc/graphql';

export const useLocationBulkSubmitterIdUpdate = (
  baseOptions?: LocationBulkSubmitterIdUpdateMutationOptions,
) => useMutation(useLocationBulkSubmitterIdUpdateMutation, baseOptions);
